import moment from "moment";
import { DatePicker } from "../../../components/forms/DatePicker";
import FormLabel from "../../../components/forms/FormLabel";
import { Text } from "rizzui";

interface TimeSelectorsProps {
    formik: any;
    required?: boolean;
    className?: string;
}

const TimeSelectors: React.FC<TimeSelectorsProps> = ({ formik, required = true, className = '' }) => {

    // RENDER 

    return (
        <>

            {/* DATE, YEAR, MONTH AND WEEK SELECTORS */}
        
            <div className={`grid md:grid-cols-3 grid-cols-1 gap-2 mt-3 mb-3 ${className}`}>

                {/* DATE SELECTOR */}

                <div className="flex flex-col">
                    <FormLabel label="Fecha" required> 
                        <DatePicker
                            className={formik.errors.date && formik.touched.date ? 'invalid-form-input w-full' : 'w-full'}
                            placeholderText="Selecciona la fecha"
                            selected={formik.values.date ? moment(formik.values.date, 'DD/MM/YYYY').toDate() : null}
                            onChange={(date: any) => {
                                const formattedDate = moment(date).format('DD/MM/YYYY');   
                                formik.setFieldValue('date', formattedDate);
                            }}
                            dateFormat="d/MM/yyyy"
                            maxDate={new Date()}
                            required
                            />      
                    </FormLabel>
                    {formik.errors.date && formik.touched.date && (
                        <Text className="text-red-500 text-sm mt-1">
                            {formik.errors.date}
                        </Text>
                    )} 
                </div>  

                

                {/* YEAR SELECTOR */}
                {/* <div className="flex flex-col">

                    <FormLabel label="Año" required>
                        <DatePicker
                            className={formik.errors.year && formik.touched.year ? 'invalid-form-input w-full' : 'w-full'}
                            inputProps={{ readOnly: true }}
                            placeholderText="Selecciona el año"
                            selected={formik.values.year ? moment(formik.values.year, 'YYYY').toDate() : null}
                            onChange={(date: any) => {
                                const formattedDate = moment(date).format('YYYY');
                                formik.setFieldValue('year', formattedDate);
                            }}
                            dateFormat="yyyy"
                            showYearPicker
                            showIcon
                            required
                        />
                    </FormLabel>

                    {formik.errors.year && formik.touched.year && (
                        <Text className="text-red-500 text-sm mt-1">
                            {formik.errors.year}
                        </Text>
                    )}
                </div> */}

                {/* MONTH SELECTOR */}
                {/* <div className="flex flex-col">
                    <CustomSelect
                        isSearchable
                        id={'month'}    
                        label="Mes"
                        options={Months}
                        onChange={(e: any) => {
                            formik.setFieldValue('month', e.value)
                        }}
                        value={
                            formik.values.month
                                ? Months.filter((month: any) => month.value === formik.values.month)
                                : null
                        }
                        error={formik.errors.month && formik.touched.month ? formik.errors.month : undefined}
                        required
                    />
                </div> */}

                {/* WEEK SELECTOR */}

                {/* <RequiredInput
                    id='week'
                    type='text'
                    value={formik.values.week || ''}
                    onChange={(e) => formik.setFieldValue('week', e.target.value)}
                    placeholder="Semana"
                    minLength={2}
                    min={1}
                    max={52}
                    maxLength={2}
                    label="Semana"
                    formik={formik}
                /> */}

                {/* TIME SELECTOR */}

                <div className="flex flex-col">
                <FormLabel label="Hora de inicio" required>
                    <DatePicker
                        className={formik.errors.time && formik.touched.time ? 'invalid-form-input w-full' : 'w-full'} 
                        placeholderText="Selecciona la hora"
                         selected={
                            formik.values.time
                            ? moment(formik.values.time, 'HH:mm', true).isValid()
                                ? moment(formik.values.time, 'HH:mm').toDate()
                                : null
                            : null
                        }
                        onChange={(date: any) => {
                            const formattedDate = moment(date).format('HH:mm');
                            formik.setFieldValue('time', formattedDate);
                        }}
                        dateFormat="HH:mm"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={5}
                        timeCaption="Hora"
                        timeFormat="HH:mm"
                        required
                    />
                </FormLabel>
                {formik.errors.time && formik.touched.time && (
                    <Text className="text-red-500 text-sm mt-1">
                        {formik.errors.time}
                    </Text>
                )}
                </div>

                {/* END TIME SELECTOR */}

                <div className="flex flex-col">
                <FormLabel label="Hora de fin" required>
                    <DatePicker 
                        className={formik.errors.endTime && formik.touched.endTime ? 'invalid-form-input w-full' : 'w-full'}
                        placeholderText="Selecciona la hora"
                        selected={
                            formik.values.time
                            ? moment(formik.values.endTime, 'HH:mm', true).isValid()
                                ? moment(formik.values.endTime, 'HH:mm').toDate()
                                : null
                            : null
                        }
                        onChange={(date: any) => {
                            const formattedDate = moment(date).format('HH:mm');
                            formik.setFieldValue('endTime', formattedDate);
                        }}
                        dateFormat="HH:mm"
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={5}
                        timeCaption="Hora"
                        timeFormat="HH:mm"
                        required
                    />
                </FormLabel>
                {formik.errors.endTime && formik.touched.endTime && (
                    <Text className="text-red-500 text-sm mt-1">
                        {formik.errors.endTime}
                    </Text>
                )}  
                </div>

            </div>
        </>
    )
}

export default TimeSelectors;

